import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import IconButton from "@material-ui/core/IconButton";
import Hidden from "@material-ui/core/Hidden";
// @material-ui/icons
import Menu from "@material-ui/icons/Menu";
// core components
import styles from "assets/jss/material-dashboard-react/components/headerStyle.js";
import AdminNavbarLinks from "./AdminNavbarLinks";
import LogoIcon from "assets/icons/care-aid.png";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";
import { getAuthInfo } from "store/slices/auth";
import { getCompanyConfig } from "store/slices/company";
import { SYSTEM_ROLE } from "config/AppConfig";

const useStyles = makeStyles((theme) => ({
  ...styles(theme),
  appBar: {
    ...styles(theme).appBar,
    color: "#555555",
  },
  title: {
    width: '60%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    flex: '1 0 0px',
    '& img': {
      maxHeight: 40,
      minWidth: 100
    }
  },
  companyName: {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    margin: '0 15px',
    fontWeight: 'bold',
    color: 'black'
  }
}));

const AdminNavbar = (props) => {
  const {
    handleDrawerToggle,
    isMobile,
    mobileOpen,
    setMobileOpen
  } = props;
  const classes = useStyles();

  const companyConfig = useSelector(getCompanyConfig) || {};
  const authInfo = useSelector(getAuthInfo) || {};

  const { color } = props;
  const appBarClasses = classNames({
    [" " + classes[color]]: color,
  });
  return (
    <>
      <AppBar className={classes.appBar + appBarClasses}>
        <Toolbar className={classes.container} style={{ alignItems: 'center', justifyContent: 'flex-start' }}>
          <Box className={classes.title}>
            {
              authInfo && authInfo.role !== SYSTEM_ROLE.SUPER_ADMIN && companyConfig
                ? !isMobile ? <>
                  <img src={companyConfig.logoAws3Link ? companyConfig.logoAws3Link : LogoIcon} />
                  <span className={classes.companyName}>{companyConfig.organizationName}</span>
                </> : <>
                  <Hidden smUp implementation="css">
                    <IconButton
                      color="inherit"
                      aria-label="open drawer"
                      onClick={handleDrawerToggle}
                    >
                      <Menu />
                    </IconButton>
                  </Hidden>
                </>
                : <img src={LogoIcon} />
            }

          </Box>
          <AdminNavbarLinks isMobile={isMobile} setMobileOpen={setMobileOpen} mobileOpen={mobileOpen} />

        </Toolbar>
      </AppBar>
    </>
  );
}

AdminNavbar.propTypes = {
  color: PropTypes.oneOf(["primary", "info", "success", "warning", "danger"]),
  rtlActive: PropTypes.bool,
  handleDrawerToggle: PropTypes.func,
  routes: PropTypes.arrayOf(PropTypes.object),
  isMobile: PropTypes.bool,
  mobileOpen: PropTypes.bool,
  setMobileOpen: PropTypes.func
};

export default AdminNavbar;